import React from 'react';
import DayTimeLarge from './DayTimeLarge';
import Rocket from 'src/data/images/new_rocket.svg';
import { mediaQueries } from 'src/style/breakpoints';

const TypicalDayLarge = () => {
  return (
    <div
      css={{
        position: 'relative',
        display: 'flex',
        flexDirection: 'row',
        justifyContent: 'flex-start',
        marginBottom: 85,
      }}
    >
      <DayTimeLarge
        title="Séance de soutien"
        text="Les élèves en difficulté sont conviés aux séances de soutien du matin (mardi et jeudi), pour retravailler les notions en petit groupe. On ne laisse personne sur le carreau !"
        startHours="08:00"
        endHours="09:00"
        lineStyled="start"
      />
      <DayTimeLarge
        title="Cours et corrections"
        text="Les exercices de la veille seront corrigés en live par le formateur. Il vous sera ensuite enseigné les notions du jour, à travers des cas concrets."
        startHours="09:00"
        endHours="13:00"
      />
      <DayTimeLarge
        title="Exercices pratiques"
        text="Le reste de la journée est dédié aux exercices, en relation avec le cours du matin. Vous allez créer plein de répliques. Place à la pratique !"
        startHours="14:00"
        endHours="18:00"
      />
      <DayTimeLarge
        title="Révisions"
        text="Une fois rentré chez vous, prenez soin de relire votre cours et de peaufiner/refaire vos exercices. Accédez au replay de tous les cours et corrections."
        startHours="Après"
        endHours="18:00"
        lineStyled="end"
      />
      <div
        css={{
          display: 'none',
          [mediaQueries.desktopUp]: {
            display: 'flex',
            flex: 0.5,
            justifyContent: 'flex-end',
            marginTop: 34,
            marginLeft: 5,
          },
        }}
      >
        <img
          src={Rocket}
          alt="illustration fusée"
          css={{ width: 152, height: 132, transform: 'rotate(90deg)' }}
        />
      </div>
    </div>
  );
};
export default TypicalDayLarge;
